// Анимация прокрутки
window.AOS = require('aos/dist/aos');

// TOASTR
window.Toastr = require('toastr');

// Отправка формы
require('vgformsender/dist/js/vgformsender');

// VGSidebar
require('vgnav/dist/vgsidebar.umd')

window.Select2 = require('select2');
require('select2/dist/js/i18n/ru');